import ModalSIngleProduct from "../components/ModalSIngleProduct";

function layout() {
  let ctxView = {
    model: "product.template",

    form_action: ["edit"],
    table_action: [],
    activeSearch: true,
    limit: 10,
    domain: [["type", "=", "goods"]],
    fields: {
      name: {
        type: "char",
        readOnly: false,
        searchable: true,
      },
      code: {
        type: "char",
        readOnly: false,
        searchable: true,
      },
      sale_uom: {
        type: "many2one",
        model: "product.uom",
      },

      cost_price: {
        type: "float",
      },
      quantity: {
        type: "integer",
        // editable: true,
      },
      unit_price: {
        type: "float",
      },
      uom: {
        type: "char",
      },
      storage: {
        type: "char",
        // model: "product.storage",
      },
      available: {
        type: "boolean",
      },
      // images: {
      //   type: "custom_component",
      //   Component: ModalSIngleProduct,
      //   visible: () => true,
      //   readOnly: false,
      //   style: null,
      //   attrs: "image_url",
      // },
      "images.image_url": {
        type: "custom_component",
        Component: ModalSIngleProduct,
        visible: () => true,
        readOnly: false,
        style: null,
        attrs: "image_url",
      },
      current_stock: {
        type: "char",
      },
      area: {
        type: "char",
      },
      business_unit: {
        type: "char",
      },
      associated_position: {
        type: "char",
      },
      description: {
        type: "char",
      },
    },
    form: [],
    list: [
      // { name: "images" },
      { name: "images.image_url" },
      { name: "name" },
      { name: "code" },
      { name: "sale_uom" },
      { name: "quantity" },
      { name: "cost_price" },
    ],
  };

  return ctxView;
}

export { layout };
